// app.vue
<template>
  <div id="app">
    <div id="loading" v-if="isloading"></div>
    <div id="main">
      <input type="hidden" id="lat" value="10" />
      <input type="hidden" id="lng" value="10" />
      <input
        type="hidden"
        id="fileName"
        value="0900"
        style="width: 0px; height: 0px"
      />
      <div id="map" style="height: 100%; width: 100%"></div>
      <div id="filedata" style="width: 0px; height: 0px"></div>
    </div>
  </div>
</template>

<script>
import {
  addFilterButtons,
  addCurrentLocationMarker,
  addThemeToggleButtons,
  changeMarkerPositionOnPressingScreen,
  addSendMessageOnMapScroll,
  getMarkerIcon,
  addStationsMarkers,
  changeMapCenter,
} from "@/services/app";

const BASE_URL_local = "/";
const VERBOSE_OUTPUT = false;

import axios from "axios";
axios.defaults.headers.common["Authorization"] =
  "Basic " + process.env.VUE_APP_API_KEY;

// import L from "leaflet";

import { orderStationSymbols } from "@/utils";
import { postMessageToReact } from "@/services/reactNativeWebView";

let leafletMap = "";
let stationsCache = [];

export default {
  name: "App",
  data() {
    return {
      isloading: true,
      fileName: "0910",
      lat: "52",
      lng: "4",
      zoom: 8,
      websiteUrl: "",
      thumbnailUrl: "",

      f: "",
      info: "",
      imagevar: "image1",
      lng1: "",
      lng2: "",
      lng3: "",
      lng4: "",

      lat1: "",
      lat2: "",
      lat3: "",
      lat4: "",
      marker: "",
      image: "",
      country: "",
      tilelayer: "",
      // streetLayer: "",

      icons: { TIDE: "m", WT: "t", Q: "c", W: "w" },

      dims: { x: 0, y: 0 },
      markers: [],
      zoomTrack: 0,
      water_filter: true,
      current_filter: false,
      temp_filter: false,
      tide_filter: false,

      marker_selected: null,
    };
  },
  mounted() {
    const self = this;

    const urlParams = new URLSearchParams(window.location.search);

    self.lat = urlParams.get("lat") || 52;
    self.lng = urlParams.get("lng") || 4;
    self.zoom = urlParams.get("zoom") || 8;
    // self.layer = urlParams.get("layer") || "tilelayer";

    this.layer = urlParams.get("layer") || "streetLayer";

    let init_filter = urlParams.get("filter") || "water";
    let filter = [true, false, false, false];
    switch (init_filter) {
      case "water":
        filter = [true, false, false, false];
        break;
      case "current":
        filter = [false, true, false, false];
        break;
      case "temperature":
        filter = [false, false, true, false];
        break;
      case "tide":
        filter = [false, false, false, true];
        break;
    }

    this.set_filters(filter);

    leafletMap = L.map("map", {
      zoomControl: false,
      attributionControl: false,
    }).setView([this.lat, this.lng], this.zoom);
    leafletMap.createPane("tiles");
    leafletMap.createPane("image");

    leafletMap.options.minZoom = 2;

    leafletMap.on("dragend", this.mapDragEnd);
    leafletMap.on("zoomend", this.mapDragEnd);
    leafletMap.on("moveend", this.mapDragEnd);

    document.addEventListener("message", function(event) {
      self.processAppRequest(event.data);
    });

    window.addEventListener("message", function(event) {
      self.processAppRequest(event.data);
    });

    let postmessage = {
      event: "MapInitialized",
      source: "waterScreen",
    };
    console.log("Message sent to the native app: ", postmessage);
    // this.dpMapInitSent("MapInitialized sent to the native app");
    setTimeout(function() {
      postMessageToReact(JSON.stringify(postmessage));
    }, 100);

    if (process.env.VUE_APP_PRO_VERSION == 1) {
      this.tilelayer = L.maplibreGL({
        attribution:
          '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
        style: process.env.VUE_APP_MAPTILER_STREET,
      });
    }

    addCurrentLocationMarker(leafletMap, self);
    addFilterButtons(leafletMap, self);

    if (process.env.VUE_APP_PRO_VERSION == 1) {
      addThemeToggleButtons(leafletMap, self);
    } else {
      this.tilelayer = L.tileLayer(process.env.VUE_APP_STADIAMAPS_URL, {});
      leafletMap.addLayer(this.tilelayer);
    }
    //

    // addThemeToggleButtons(leafletMap, self);
    changeMarkerPositionOnPressingScreen(leafletMap, self);
    addSendMessageOnMapScroll(leafletMap, self);

    this.getStationsList(false);
  },
  methods: {
    async processAppRequest() {
      try {
        // var obj = null;
        // if (typeof postmessage === "object" && postmessage !== null) {
        //   obj = postmessage;
        // } else {
        //   obj = JSON.parse(postmessage);
        // }

        switch (event.data.event_id) {
          case "message":
            break;
          case "updateLocation":
            var postmessage = event.data;
            console.log("wind screen common handler : ", postmessage);
            console.log(typeof postmessage);
            let coordinates = postmessage.data;
            if (
              coordinates.hasOwnProperty("latitude") &&
              coordinates.hasOwnProperty("longitude") &&
              coordinates.hasOwnProperty("countryCode")
            ) {
              var newLatLng = new L.LatLng(
                coordinates.latitude,
                coordinates.longitude
              );
              console.log(":: newLatLng", newLatLng);
              changeMapCenter(
                leafletMap,
                this,
                newLatLng,
                coordinates.countryCode
              );
            }
            break;
          case "countryCode":
            if (event.data.data.hasOwnProperty("countryCode")) {
              this.country = event.data.data.countryCode;
              this.getStationsList(false);
            }
            break;
          default:
            console.log("ERROR: unknown event type");
        }
      } catch (err) {
        console.log("ERROR in Android fun: ", err);
      }
    },
    set_filters: function(filter) {
      this.water_filter = filter[0];
      this.current_filter = filter[1];
      this.temp_filter = filter[2];
      this.tide_filter = filter[3];
    },
    addMarker: function(lon, lat, uid, iconMarker, initial_type, is_selected) {
      const _this = this;

      var marker = L.marker([lat, lon], {
        icon: getMarkerIcon(_this, iconMarker, is_selected),
      });

      marker.properties = {
        uuid: uid,
        st_type: iconMarker,
        full_type: initial_type,
      };

      marker.on("click", function(event) {
        if (VERBOSE_OUTPUT) console.log(event);
        var attributes = event.sourceTarget.properties;
        if (VERBOSE_OUTPUT)
          console.log(
            "A marker with uuid = ",
            attributes.uuid,
            "; type = ",
            attributes.st_type,
            " has been clicked"
          );

        // find marker
        if (_this.marker_selected != null) {
          if (_this.marker_selected.id === attributes.uuid) {
            // Click on the same icon
            if (VERBOSE_OUTPUT)
              console.log("============ the same single marker =========");
            return;
          } else {
            // 1. replace pins in old selection and place it back to the array
            let st_type = _this.marker_selected.m.properties.st_type;
            let full_type = _this.marker_selected.m.properties.full_type;
            let lon_tmp = _this.marker_selected.lon;
            let lat_tmp = _this.marker_selected.lat;
            let id_tmp = _this.marker_selected.id;

            // 2. remove from the map old selection
            if (VERBOSE_OUTPUT)
              console.log(
                " - >>> Going to remove old seletion",
                _this.marker_selected.m
              );
            leafletMap.removeLayer(_this.marker_selected.m);
            _this.marker_selected = null;
            let deselected_icon = st_type.replaceAll("_", "");
            if (VERBOSE_OUTPUT)
              console.log(
                "```````````` selected icon changed from ",
                st_type,
                " to ",
                deselected_icon
              );
            //  add old selected to array and map
            _this.addMarker(
              lon_tmp,
              lat_tmp,
              id_tmp,
              deselected_icon,
              full_type,
              false
            );
          }
        } else {
          if (VERBOSE_OUTPUT) console.log("==== No selection yet === ");
        }
        // 1. find and remove the new selection from the map and array
        let mrk = _this.extract_marker_by_id(attributes.uuid);
        if (VERBOSE_OUTPUT) console.log("### Extracted marker:", mrk);

        // 3. add to selected and map the new selected marker
        let st_type_sel = _this.selectType(
          mrk.m.properties.st_type,
          attributes.st_type
        );

        _this.addMarker(
          mrk.lon,
          mrk.lat,
          mrk.id,
          st_type_sel,
          mrk.m.properties.full_type,
          true
        );

        _this.sendToNativeApp(attributes.uuid, attributes.st_type);
      });

      // add marker to the array and to the map (if not present on the map)
      if (!is_selected) {
        // it is a regular marker
        if (this.addMarkerToArray(marker, lon, lat, uid)) {
          marker.addTo(leafletMap);
        }
      } else {
        if (VERBOSE_OUTPUT) console.log("Selected marker added");
        if (this.addMarkerToSelection(marker, lon, lat, uid)) {
          this.marker_selected.m.addTo(leafletMap);
        }
      }
    },
    selectType: function(type, sel_type) {
      let VERBOSE_OUTPUT = false;
      let ret = type.replace(sel_type, "_" + sel_type + "_");
      if (VERBOSE_OUTPUT)
        console.log(
          "************** before: ",
          type,
          "(",
          sel_type,
          ")",
          " after ",
          ret
        );
      return ret;
    },

    extract_marker_by_id: function(id) {
      for (var i = this.markers.length - 1; i >= 0; i--) {
        if (this.markers[i].id.localeCompare(id) === 0) {
          let marker = this.markers[i];
          leafletMap.removeLayer(this.markers[i].m);
          this.markers.splice(i, 1);
          return marker;
        }
      }
      return null;
    },
    addMarkerToArray(mrk, ln, lt, uid) {
      // add marker to the array
      let isInArray = false;
      let VERBOSE_OUTPUT = false;

      // check if it is a selected marker
      if (this.marker_selected != null) {
        if (this.marker_selected.id === uid) {
          if (VERBOSE_OUTPUT)
            console.log(
              "______________ the marker is in the selected",
              this.marker_selected
            );
          return false;
        }
      }

      for (let i = 0; i < this.markers.length; i++) {
        let new_type = mrk.properties.st_type;
        let old_type = this.markers[i].m.properties.st_type;

        if (this.markers[i].id === uid) {
          if (VERBOSE_OUTPUT)
            console.log("<<<<<<<<<<<<<<< ", old_type, new_type, ">>>>>>>>>>.");
          if (old_type.localeCompare(new_type) === 0) {
            isInArray = true;
            return false;
          } else {
            // marker should be updated - remove it here; the new marker will be added outside of this function
            leafletMap.removeLayer(this.markers[i].m);
            this.markers.splice(i, 1);
            break;
          }
        }
      }

      if (!isInArray) {
        let item = { m: mrk, lon: ln, lat: lt, id: uid };
        this.markers.push(item);
        return true;
      }
      return false;
    },
    addMarkerToSelection(mrk, ln, lt, uid) {
      // put marker to the selected marker
      this.marker_selected = { m: mrk, lon: ln, lat: lt, id: uid };
      return true;
    },

    initClickEvent(id, tp) {
      const event = new Event("station", {
        station: id,
        type: tp,
      });

      document.addEventListener("station", (event) => {
        console.log("=========================");
        console.log("    ======= station selected!");
        console.log("=========================");
        console.log(event);
        console.log("=========================");
      });
      document.dispatchEvent(event);
    },
    getStationType: function(len, hz, px) {
      let left_border = -(len * hz) / 2;
      console.log("left_border", left_border);
      for (var i = 0; i < len; i++) {
        console.log("left_border", "i", i, ": ", left_border, "px = ", px);
        if (px >= left_border && px < left_border + hz) {
          return i;
        }
        left_border += hz;
      }
      return -1;
    },
    cleanMarkers(lon1, lon2, lat1, lat2) {
      if (VERBOSE_OUTPUT) console.log("------> cleanMarkers in");

      // if (this.zoomTrack - leafletMap.getZoom() > 0) {
      if (leafletMap.getZoom() <= 10) {
        // remove most markers
        let perc_to_leave = 0.2; // keep only that portion of stations
        for (
          var i = this.markers.length - 1;
          i >= Math.round(perc_to_leave * this.markers.length);
          i--
        ) {
          leafletMap.removeLayer(this.markers[i].m);
          this.markers.splice(i, 1);
        }
        // ??? TODO what's ???
        this.zoomTrack = leafletMap.getZoom();
      } else {
        if (VERBOSE_OUTPUT)
          console.log("======= Entered to removing", lon1, lon2, lat1, lat2);
        let indcsToRemove = [];
        for (let i = 0; i < this.markers.length; i++) {
          let m = this.markers[i];
          if (
            m.lon >= lon1 &&
            m.lon <= lon2 &&
            m.lat >= lat1 &&
            m.lat <= lat2
          ) {
            // keep the marker
          } else {
            indcsToRemove.push(i);
          }
        }
        // go over array with collected indices and remove elements
        for (let i = 0; i < indcsToRemove.length; i++) {
          if (VERBOSE_OUTPUT)
            console.log(
              "removing marker ",
              i,
              indcsToRemove[i],
              "uid",
              this.markers[indcsToRemove[i]].id
            );
          leafletMap.removeLayer(this.markers[indcsToRemove[i]].m);
        }
        if (VERBOSE_OUTPUT)
          console.log("before clean, arr. len", this.markers.length);
        for (let i = indcsToRemove.length - 1; i >= 0; i--)
          this.markers.splice(indcsToRemove[i], 1);

        if (VERBOSE_OUTPUT)
          console.log("after clean, arr. len", this.markers.length);
      }

      if (VERBOSE_OUTPUT) console.log("<------ cleanMarkers out");
    },

    filter_type: function() {
      if (VERBOSE_OUTPUT) console.log("------> filter_type in");

      for (var i = this.markers.length - 1; i >= 0; i--) {
        let marker_t = this.markers[i].m.properties.st_type;
        let initial_type = this.markers[i].m.properties.full_type;
        let marker_t_filtered = marker_t;
        // apply selected filter
        if (VERBOSE_OUTPUT) {
          console.log("*cf", this.current_filter);
          console.log("*tf", this.temp_filter);
          console.log("*tf", this.water_filter);
          console.log("*tdf", this.tide_filter);
          console.log("marker_t = ", marker_t);
        }
        if (!this.current_filter) {
          marker_t_filtered = marker_t_filtered.replace("c", "");
        }
        if (!this.temp_filter) {
          marker_t_filtered = marker_t_filtered.replace("t", "");
        }
        if (!this.water_filter) {
          marker_t_filtered = marker_t_filtered.replace("w", "");
        }
        if (!this.tide_filter) {
          marker_t_filtered = marker_t_filtered.replace("m", "");
        }
        if (VERBOSE_OUTPUT) {
          console.log(
            "-> marker_t_filtered after filtering = ",
            marker_t_filtered
          );
          console.log(
            marker_t_filtered,
            "==",
            marker_t,
            marker_t.localeCompare(marker_t_filtered)
          );
        }
        if (marker_t.localeCompare(marker_t_filtered) === 0) {
          // not changed
          if (VERBOSE_OUTPUT) {
            console.log("--Nothing changed");
          }
        } else {
          // changed
          if (marker_t_filtered.length === 0) {
            if (VERBOSE_OUTPUT) {
              console.log(
                "marker_t_filtered will be removed completely",
                marker_t_filtered
              );
            }

            // filtered out completely
            leafletMap.removeLayer(this.markers[i].m);
            this.markers.splice(i, 1);
          } else {
            /* replace marker */
            // 1. remove old marker
            leafletMap.removeLayer(this.markers[i].m);
            // 2. replace parameter of the marker in the list
            let stations_ordered = orderStationSymbols(marker_t_filtered);
            if (VERBOSE_OUTPUT) {
              console.log(
                "++++++++ going to replacd: before: ",
                marker_t_filtered,
                "ordered: ",
                stations_ordered
              );
            }
            let lon_tmp = this.markers[i].lon;
            let lat_tmp = this.markers[i].lat;
            let id_tmp = this.markers[i].id;

            // 3. remove old marker from the list (the new one will not be added otherwise)
            this.markers.splice(i, 1);

            // 4. add updated marker back to the map. Merkers' array updated in addCurrentLocationMarker
            this.addMarker(
              lon_tmp,
              lat_tmp,
              id_tmp,
              stations_ordered,
              initial_type,
              false
            );
          }
        }
      }

      console.log("<------ filter_type out");
    },
    getStationsList: function(filterChanged) {
      if (VERBOSE_OUTPUT) {
        console.log("------> getStationsList in");
        console.log("Filter changed: ", filterChanged);
      }

      let _this = this;

      let zoomLevel = leafletMap.getZoom();
      let bndrs = leafletMap.getBounds();
      let sw_x = bndrs._southWest.lng;
      let sw_y = bndrs._southWest.lat;
      let ne_x = bndrs._northEast.lng;
      let ne_y = bndrs._northEast.lat;

      // clean current markers array
      this.cleanMarkers(sw_x, ne_x, sw_y, ne_y);

      // get ids of all markers that are left
      var id_st = [];
      for (var i = 0; i < this.markers.length; i++) {
        id_st.push(this.markers[i].id);
      }

      const url = `${BASE_URL_local}api/stations`;

      // track the zoom level for a better distribution of markers on the map
      this.zoomTrack = leafletMap.getZoom();

      let stations_filter_type = "";
      if (this.current_filter) {
        stations_filter_type = "c";
      } else if (this.temp_filter) {
        stations_filter_type = "t";
      } else if (this.water_filter) {
        stations_filter_type = "w";
      } else if (this.tide_filter) {
        stations_filter_type = "m";
      }

      if (this.marker_selected) {
        if (VERBOSE_OUTPUT) console.log(this.marker_selected);

        leafletMap.removeLayer(this.marker_selected.m);

        if (
          filterChanged &&
          this.marker_selected.m.properties.full_type.includes(
            stations_filter_type
          )
        ) {
          this.sendToNativeApp(this.marker_selected.id, stations_filter_type);
          this.addMarker(
            this.marker_selected.lon,
            this.marker_selected.lat,
            this.marker_selected.id,
            "_" + stations_filter_type + "_",
            this.marker_selected.m.properties.full_type,
            true
          );
        } else {
          this.sendCloseChartToNativeApp();
          _this.marker_selected = null;
        }
      }

      if (VERBOSE_OUTPUT)
        console.log("request: ", {
          type: stations_filter_type,
          lon1: sw_x,
          lon2: ne_x,
          lat1: sw_y,
          lat2: ne_y,
          zoom: zoomLevel,
          ids: id_st,
          country: _this.country,
        });

      let cacheKey = stations_filter_type + _this.country;

      if (cacheKey in stationsCache) {
        //TODO add TTL. Consider native app cache OR browser cache
        addStationsMarkers(
          stationsCache[cacheKey],
          leafletMap,
          _this,
          stations_filter_type,
          sw_x,
          ne_x,
          sw_y,
          ne_y,
          zoomLevel,
          id_st
        );
      } else {
        axios
          .post(url, {
            type: stations_filter_type,
            country: _this.country,
            lon1: sw_x,
            lon2: ne_x,
            lat1: sw_y,
            lat2: ne_y,
            zoom: zoomLevel,
            ids: id_st,
          })
          .then((resp) => {
            addStationsMarkers(
              resp.data.stations,
              leafletMap,
              _this,
              stations_filter_type,
              sw_x,
              ne_x,
              sw_y,
              ne_y,
              zoomLevel,
              id_st
            );
            stationsCache[cacheKey] = resp.data.stations;
          })
          .catch((err) => {
            console.log("Error while requesting the station list: ", err);
          });
      }

      if (VERBOSE_OUTPUT) console.log("<------ getStationsList out");
    },
    mapDragEnd() {
      this.getStationsList(false);
      postMessageToReact(
        JSON.stringify({ event_id: "zoomChange", zoom: leafletMap.getZoom() })
      );
      if (VERBOSE_OUTPUT) {
        console.log("******** zoom finished");
        console.log("zoom: ", leafletMap.getZoom());
        console.log("bounds: ", leafletMap.getBounds());
      }
    },

    //TODO do we need it ?
    mapDragStart() {
      if (VERBOSE_OUTPUT) console.log("start");
      postMessageToReact("started", "*");
    },

    //TODO do we need it ?
    onMoveEnd() {
      const cordinates = this.marker.getLatLng();
      setTimeout(function() {
        postMessageToReact(JSON.stringify(cordinates));
      });
    },

    sendToNativeApp(id, tp) {
      console.log("***************************************");
      let data = JSON.stringify({ m_name: "station", s_id: id, st_type: tp });
      console.log("Sent to native: ", data);

      setTimeout(function() {
        postMessageToReact(data);
      }, 500);
    },

    sendCloseChartToNativeApp() {
      console.log("***************************************");
      let data = JSON.stringify({ m_name: "close_chart" });
      console.log("Sent to native: ", data);

      setTimeout(function() {
        postMessageToReact(data);
      }, 500);
    },
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*Fixed an issue in IOS where a long press would bring up the magnifying glass. Also fixed the contextmenu event in Leaflet map*/
  user-select: none;
  -webkit-user-select: none;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
